import { reportError } from './dev-api-service'
import { DevApiErrorType } from './dev-api-error-type'

export const sensorsDevApi = { reportError, DevApiErrorType }
